<script lang="ts">
  import { page } from '$app/stores';
  import { env as envPublic } from '$env/dynamic/public';
  import { Navbar, NavBrand, NavLi, NavUl } from 'flowbite-svelte';
  import SearchInput from '$components/locations/+searchInput.svelte';
  import type { ItemNav, ProfileLinks, Balance } from '$utils/types';
  import NotificationBell from './notifications/NotificationBell.svelte';

  // Branding props
  export let logo: string;

  export let logoId = 'logo';
  export let logoRedirectTo = '/';
  export let navbarClassName = '';

  // Navigation props
  export let items: ItemNav[];
  export let additional_items: ItemNav[] | null | undefined = undefined;
  export let isBurgerVisible = true;
  export let redirectUrl = '';
  export let searchParam = 'filter[s]';
  export let isEmbedded: boolean | null | undefined = false;

  // Auth / Profile props
  export let loggedIn;
  export let showLogin = true;
  export let showLoginMobile = false;
  export let showProfileLink = false;
  export let profileLinks: ProfileLinks = {
    first: { href: '', label: '' },
    second: { href: '', label: '' },
    mobile: { href: '', label: '' },
  };

  // Balance props
  export let showBalance = false;
  export let balance: Balance = { value: 0 };
  export let currencyText = 'kr.';

  // Search
  export let searchShown;
  export let mobileSearchShown = true;

  // Internal state
  let menuOpen = false;

  const toggleMenu = () => {
    menuOpen = !menuOpen;
  };

  const handleSearch = () => {
    menuOpen = false;
  };

  // Event callbacks
  export let onNotificationBellClick: (() => void) | undefined = undefined;

  // State flags
  export let isUnread = false;

  export let notificationEnabled = false;
</script>

<NavBrand href={logoRedirectTo} id={logoId}>
  <img src={logo} alt={envPublic.PUBLIC_APP_NAME} />
</NavBrand>
{#if showLoginMobile}
  {#if loggedIn}
    <div class="mobile-profile">
      <div class="balance-nav">
        <span class="value">{balance?.value?.toFixed(2) || 0} {currencyText}</span>
      </div>
    </div>

    {#if notificationEnabled}
      <div class="mobile-notifications">
        <NotificationBell {isUnread} onClick={() => onNotificationBellClick?.()} width={24} height={24} />
      </div>
    {/if}
  {:else}
    <div class="mobile-signup signup">
      <a href={profileLinks.mobile?.href}>{profileLinks.mobile?.label}</a>
    </div>
  {/if}
{/if}
<Navbar class={`top-nav-menu ${menuOpen ? 'menu-open' : 'menu-closed'} ${navbarClassName}`}>
  {#if isBurgerVisible}
    <div class="hamburger">
      <button class="open-menu" on:click={toggleMenu}>
        <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M5 7h14M5 12h14M5 17h14" />
        </svg>
      </button>
      <button class="close-menu" on:click={() => (menuOpen = !menuOpen)}>
        <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18 17.94 6M18 18 6.06 6" />
        </svg>
      </button>
    </div>
  {/if}
  <NavUl class="nav-links">
    <!-- Display whatever is passed to items -->
    {#each items as item}
      <NavLi href={item.href} target={item.target ?? '_self'} rel={item.rel} class="{item.highlight ? 'highlight' : ''} {$page.url.pathname.includes(item.href) ? 'active' : ''}">{item.label}</NavLi>
    {/each}
  </NavUl>
</Navbar>

{#if searchShown}
  <SearchInput {searchParam} {redirectUrl} liveSearchEnabled={false} {isEmbedded} />
{/if}

<div class="mobile-menu">
  <div class="wrap">
    {#if loggedIn && showBalance}
      <div class="balance-nav">Saldo: <span class="value">{balance?.value?.toFixed(2) || 0} kr.</span></div>
    {/if}

    <!-- Show search input in burger menu -->
    {#if mobileSearchShown}
      <SearchInput {searchParam} {redirectUrl} liveSearchEnabled={false} on:search={handleSearch} />
    {/if}

    {#if loggedIn && showProfileLink}
      <div class="profile">
        <a href="/min-konto" on:click={toggleMenu}>Profil</a>
      </div>
    {/if}

    <NavUl class="nav-links">
      <!-- Only on main nav and only when these additional items are passed -->
      {#if additional_items && additional_items.length > 0}
        {#each additional_items as item, i}
          <NavLi href={item.href} target={item.target ?? '_self'} rel={item.rel} class="{item.highlight ? 'highlight' : ''} {$page.url.pathname.includes(item.href) ? 'active' : ''}" on:click={toggleMenu}>
            {item.label}
          </NavLi>
          {#if i === additional_items.length - 1}
            <div class="nav-links-divider"></div>
          {/if}
        {/each}
      {/if}
      {#each items as item}
        <NavLi href={item.href} target={item.target ?? '_self'} rel={item.rel} class={item.highlight ? 'highlight' : ''} on:click={toggleMenu}>
          {item.label}
        </NavLi>
      {/each}
    </NavUl>
    {#if showLogin}
      {#if loggedIn}
        <div class="profile-second">
          <a href="/min-konto" on:click={toggleMenu}>Profil</a>
        </div>
      {:else}
        <div class="login">
          <a href={profileLinks.first.href} on:click={toggleMenu}>{profileLinks.first.label}</a>
          <a href={profileLinks.second.href} on:click={toggleMenu}>{profileLinks.second.label}</a>
        </div>
      {/if}
    {/if}
  </div>
</div>
